import { Box } from '../types';

export interface CSVRow {
  product_id?: string;
  length: number;
  width: number;
  height: number;
  quantity: number;
}

export const parseCSV = (csvText: string): CSVRow[] => {
  const lines = csvText.trim().split('\n');
  if (lines.length < 2) {
    throw new Error('CSV file must have at least a header row and one data row');
  }

  const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
  
  // Check for required headers
  const requiredHeaders = ['length', 'width', 'height', 'quantity'];
  const missingHeaders = requiredHeaders.filter(h => !headers.includes(h));
  
  if (missingHeaders.length > 0) {
    throw new Error(`Missing required headers: ${missingHeaders.join(', ')}`);
  }

  // Check for optional product_id header
  const hasProductId = headers.includes('product_id') || headers.includes('asin');

  const rows: CSVRow[] = [];
  
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue; // Skip empty lines
    
    const values = line.split(',').map(v => v.trim());
    
    if (values.length < requiredHeaders.length) {
      throw new Error(`Row ${i + 1}: Insufficient data columns`);
    }

    const row: CSVRow = {
      length: parseFloat(values[headers.indexOf('length')]),
      width: parseFloat(values[headers.indexOf('width')]),
      height: parseFloat(values[headers.indexOf('height')]),
      quantity: parseInt(values[headers.indexOf('quantity')])
    };

    // Add product_id if present
    if (hasProductId) {
      const productIdIndex = headers.indexOf('product_id') !== -1 ? headers.indexOf('product_id') : headers.indexOf('asin');
      if (productIdIndex !== -1 && values[productIdIndex]) {
        row.product_id = values[productIdIndex];
      }
    }

    // Validate numeric values
    if (isNaN(row.length) || isNaN(row.width) || isNaN(row.height) || isNaN(row.quantity)) {
      throw new Error(`Row ${i + 1}: Invalid numeric values`);
    }

    if (row.length <= 0 || row.width <= 0 || row.height <= 0 || row.quantity <= 0) {
      throw new Error(`Row ${i + 1}: All dimensions and quantity must be positive`);
    }

    rows.push(row);
  }

  return rows;
};

export const convertToBoxes = (csvRows: CSVRow[]): Box[] => {
  return csvRows.map((row, index) => ({
    id: `csv-${Date.now()}-${index}`,
    length: row.length,
    width: row.width,
    height: row.height,
    quantity: row.quantity,
    asin: row.product_id
  }));
};

export const generateSampleCSV = (): string => {
  return `product_id,length,width,height,quantity
B08N5WRWNW,30,20,15,10
B07ZPKBL9V,40,30,25,8
B09B3ZXF5L,35,25,20,12`;
}; 